import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import { CustomLinkComponent } from '../../../index'

const CartFooterLinks = () => {
  const { formatMessage } = useIntl()
  const {
    theme: {
      font: { regular: fontRegular }
    }
  } = useConfig()

  const bottomLinks = [
    {
      id: 'contact',
      href: '/service',
      message: formatMessage({
        id: 'msp.cart.bottom.links.contact',
        defaultMessage: 'Contact'
      })
    },
    {
      id: 'service',
      href: '/service',
      message: formatMessage({
        id: 'msp.cart.bottom.links.service',
        defaultMessage: 'Service'
      })
    },
    {
      id: 'agb',
      href: '/conditions',
      message: formatMessage({
        id: 'msp.cart.bottom.links.agb',
        defaultMessage: 'agb'
      })
    },
    {
      id: 'shipingAndPayment',
      href: '/about-your-order',
      message: formatMessage({
        id: 'msp.cart.bottom.links.shiping.and.payment',
        defaultMessage: 'Shipping & Payment'
      })
    }
  ]

  return (
    <div className='checkout-left hidden flex-row items-center justify-center space-x-5 pt-4 md:flex'>
      {bottomLinks.map((link: any) => (
        <CustomLinkComponent
          key={link.id}
          className={`${fontRegular} space-x-2 uppercase text-white`}
          colorScheme='secondary'
          href={link.href}
        >
          {link.message}
        </CustomLinkComponent>
      ))}
    </div>
  )
}

export default CartFooterLinks
